import { Component } from '@angular/core';
import { MyMonitoringService } from '../../services/logging.service';

@Component({
  selector: 'app-failed-login-request',
  standalone: true,
  imports: [],
  templateUrl: './failed-login-request.component.html',
  styleUrl: './failed-login-request.component.scss'
})
export class FailedLoginRequestComponent {
constructor(
  private monotoringService: MyMonitoringService
) {}
}
